import api from '../../services/api';

// Mock proposals dataset and fetcher (kept as fallback)
const sampleProposals = Array.from({ length: 24 }).map((_, i) => {
  const id = 2238 + i;
  const statuses = ['Em elaboração', 'Enviado', 'Negociação', 'Fechado', 'Perdido'];
  const status = statuses[i % statuses.length];
  const values = [18500, 24000, 68000, 42000, 138000, 215000, 46700, 19800, 37600, 55000];

  // create deterministic creation dates: newer items first (lower i = newer)
  const daysAgo = i * 2; // spaced by 2 days
  const createdAt = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000).toISOString();

  return {
    id: `ORC-00${id}`,
    title: ['Residência Alto Padrão','Loja Concept','Escritório Corporate','Farmácia São Lucas','Condomínio Bella Vista','Edifício Comercial Prime','Academia Performance','Apartamento Decorado','Pousada Tropical','Casa de Campo'][i % 10],
    client: ['Mateus da Silva','Concept Store','Empresa ABC','São Lucas Ltda.','Bella Vista Empreend.','Prime Incorporadora','Performance Fitness','Maria Oliveira','Pousada Tropical','Pedro Mendes'][i % 10],
    // store numeric value (in BRL cents not required since JS number supports decimals)
    value: values[i % values.length],
    status,
    createdAt,
    updated: `${(i % 5) + 1} dias`,
    team: [{ name: 'Mateus' }, { name: 'Maria' }].slice(0, (i % 3) + 1)
  };
});

export async function getProposals({ page = 1, perPage = 12, status = 'Todos', q = '' } = {}) {
  // Try backend first; fall back to mocks on error or unexpected shape
  try {
    // build params but avoid sending default/empty filters that backend may interpret
    const params = { page, perPage };
    if (status && status !== 'Todos') params.status = status;
    if (q) params.q = q;

    const res = await api.get('/proposals', { params });
    const data = res.data;

    try { console.log('getProposals: backend raw response', data); } catch (e) {}

    // Normalize various possible shapes from the backend into { items, total }
    let items = null;
    let total = null;

    if (Array.isArray(data)) {
      items = data;
      total = data.length;
    } else if (data) {
      if (Array.isArray(data.items)) {
        items = data.items;
        total = typeof data.total === 'number' ? data.total : (Array.isArray(data.items) ? data.items.length : null);
      } else if (data.data && Array.isArray(data.data.items)) {
        items = data.data.items;
        total = typeof data.data.total === 'number' ? data.data.total : (Array.isArray(data.data.items) ? data.data.items.length : null);
      } else if (Array.isArray(data.results)) {
        items = data.results;
        total = typeof data.count === 'number' ? data.count : data.results.length;
      }
    }

    if (items) {
      // Normalize creation date field names coming from different backends
      items = items.map(it => {
        const created = it.createdAt || it.created_at || it.created || it.date || it.createdOn || it.created_on || it.created_at_iso || it.createdAtISO || it.updated || it.updated_at || it.updatedAt || null;
        return Object.assign({}, it, { createdAt: created });
      });
      // apply pagination slice if backend returned a full array
      if (!data.items && Array.isArray(items) && typeof perPage === 'number') {
        const start = (page - 1) * perPage;
        items = items.slice(start, start + perPage);
      }
      try { console.log('getProposals: normalized API response', { items, total }); } catch (e) {}
      return { items, total: typeof total === 'number' ? total : items.length };
    }

    // Unexpected shape — fall through to mock fallback
  } catch (err) {
    // console.warn('getProposals API failed, using mock data', err);
  }

  // Fallback mock behaviour (kept for local development)
  return new Promise((resolve) => {
    setTimeout(() => {
      // ensure newest first by createdAt (descending)
      let items = sampleProposals.slice().sort((a, b) => {
        const da = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const db = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return db - da;
      });
      // Status filtering temporarily disabled — backend may handle this
      // if (status && status !== 'Todos') items = items.filter(p => p.status === status);
      if (q) {
        const ql = q.toLowerCase();
        items = items.filter(p => p.title.toLowerCase().includes(ql) || p.client.toLowerCase().includes(ql) || p.id.toLowerCase().includes(ql));
      }
      const total = items.length;
      const start = (page - 1) * perPage;
      const paged = items.slice(start, start + perPage);
      resolve({ items: paged, total });
    }, 250);
  });
}
